export class PageInfo {
  totalItems!: number;
  currentPage!: number;
  startIndex!: number;
  endIndex!: number;
  pages!: Array<number>;
  endPage!: boolean;
  endPageNumber!: number;
  pageCount!: number;
}
  